<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div id="app">
    <router-view />
    <ContactButton class="contact-button" />
  </div>
</template>

<script>
import ContactButton from "@/components/ContactButton.vue";

export default {
  components: {
    ContactButton
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "Faune";
  font-weight: 400;
  src: url("https://cdn.exploreve.fr/content/fonts/faune/Webfonts/woff2/Faune-Text_Regular.woff2") format("woff2");
}

@font-face {
  font-family: "Faune";
  font-weight: 600;
  src: url("https://cdn.exploreve.fr/content/fonts/faune/Webfonts/woff2/Faune-Text_Bold.woff2") format("woff2");
}

@font-face {
  font-family: "Faune";
  font-weight: 300;
  font-style: italic;
  src: url("https://cdn.exploreve.fr/content/fonts/faune/Webfonts/woff2/Faune-Text_Italic.woff2") format("woff2");
}

@font-face {
  font-family: "Faune";
  font-weight: 900;
  src: url("https://cdn.exploreve.fr/content/fonts/faune/Webfonts/woff2/Faune-Display_Black.woff2") format("woff2");
}

@font-face {
  font-family: "Faune";
  font-weight: 300;
  src: url("https://cdn.exploreve.fr/content/fonts/faune/Webfonts/woff2/Faune-Text_Regular.woff2") format("woff2");
}

html,
body,
#app {
  background-color: $primary;
}

#app {
  font-family: "Faune", Avenir, Helvetica, Arial, sans-serif;
  font-weight: normal;
  text-align: center;
  color: $font-color;

  h1 {
    font-weight: 600;
    margin-top: 2em;
  }

  h3 {
    font-weight: 900;
  }

  p {
    font-weight: 400;
  }

  a,
  a:hover,
  a:active {
    color: $dark;
    text-decoration: underline;
  }

  .form-control {
    width: auto;
    margin: 0 auto;
  }

  .contact-button {
    position: fixed;
    z-index: 99;
    bottom: 90px;
    right: 0;
    margin: 30px;
  }
}
</style>
